import { EstimationTabLabels } from '@/constants/Forecaster/EstimationTabs';
import PropTypes from 'prop-types';

const ViewLength = ({ lengthId, value }) => {
  if (lengthId === 3) {
    return (
      <div className='flex flex-col justify-center items-center'>
        <div>{EstimationTabLabels[lengthId]}:</div>
        <div className='center text-[#5f5c62]'>{value}</div>
      </div>
    );
  }
  return <div>{EstimationTabLabels[lengthId]}</div>;
};

ViewLength.propTypes = {
  lengthId: PropTypes.number,
  value: PropTypes.string,
};

export default ViewLength;
